import { useContext, useEffect, useState } from 'react';
import Minus from "../../../../Assets/MinusCheckbox.svg";
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import { useDispatch, useSelector } from 'react-redux';
import CategoryBar from './CategoryBar';
import { useLocation, useNavigate } from 'react-router-dom';
import PlusIcon from "../../../../Assets/PlusIcon/Add.svg";
import { CategoriesContext } from '../../../../Context/Collections/CategoryContext';
import { setModal } from '../../../../Features/collectionsSlice';
import Modal from './Modal/Modal';

function Categories() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [checkboxType, setCheckboxType] = useState('');

    const { selectedCategories, setSelectedCategories } = useContext(CategoriesContext);

    const categories = useSelector((state) => state.collections.categories.categories);

    const handleCheckboxClick = () => {
        if(selectedCategories.length < categories.length) {
            if(selectedCategories.length === 0) {
                let listId = categories.map(item => item.id);
                setSelectedCategories(listId);
            }
            else {
                setSelectedCategories([]);
            }
        }
        else {
            setSelectedCategories([]);
        }
    }

    useEffect(() => {
        if(selectedCategories.length < categories?.length) {
            if(selectedCategories?.length === 0) {
                setCheckboxType('');
            }
            else {
                setCheckboxType('half')
            }
        }
        else if(selectedCategories?.length === 0) {
            setCheckboxType('');
        }
        else {
            setCheckboxType('full');
        }
    }, [selectedCategories, categories]);

    const handleAddCategory = () => {
        if(selectedCategories.length > 0) {
            setSelectedCategories([]);
        }
        navigate(`${location.pathname}/categories/add-category`);
    }

    const handleDeleteList = () => {
        dispatch(setModal('delete-confirm'));
    }

    const handleHideList = () => {
        dispatch(setModal('hide-confirm'));
    }
    
    return (
        <div className="flex flex-col mt-6 mx-5">
            <div className="flex bg-[#F5F5F5] font-semibold text-[#121212] text-[16px] leading-8">
                <div className="flex items-center gap-2 w-[calc((54/100)*(100%-44px))] px-[10px] py-[8px]">
                    {
                        categories.length > 0 &&
                        <div onClick={handleCheckboxClick} className={`cursor-pointer size-6 bg-[#FFFFFF] flex items-center justify-center rounded-md border ${checkboxType !== '' ? 'border-none bg-primaryAccent' : 'border-[#D1D5DB]'} `} >
                            <img className='select-none' src={checkboxType === 'full' ? TickMark : checkboxType === '' ? undefined : Minus} alt="" />
                        </div>
                    }

                    <h2 className="">Main Categories</h2>
                </div>

                <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Total Collection(s)</h2>
                <h2 className="w-[calc((18/100)*(100%-44px))] px-[10px] py-[8px]">Total Product(s)</h2>
                <h2 className="w-[calc((10/100)*(100%-44px))] px-[10px] py-[8px]">Mark Active</h2>
                <div className="w-[44px]"></div>
            </div>

            {[ ...categories ]?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(category => {
                const isSelected = selectedCategories.includes(category.id);

                return (
                    <CategoryBar 
                        key={category.id} 
                        category={category} 
                        isSelected={isSelected} 
                    />
                )
            })}

            {
                categories.length === 0 && 
                <div className="mx-auto mt-20 flex flex-col items-center gap-6 w-3/5">
                    <div className="flex flex-col gap-2 text-[#666666] items-center">
                        <h1 className='font-semibold text-[18px] leading-7'>No categories are added yet</h1>

                        <p className='text-center font-medium text-[16px] leading-7'>Looks like you haven’t set up any categories. Create your first category to organize your products and make managing your inventory a breeze.</p>
                    </div>

                    <button onClick={handleAddCategory} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Add Category
                    </button>
                </div>
            }

            {
                selectedCategories.length > 0 && 
                <div className="fixed left-1/2 -translate-x-1/2 bottom-12 border border-[#EAEAEA] bg-[#F5F5F5] rounded-xl p-4 flex items-center gap-3">
                    <p className='font-medium text-[14px] leading-5 text-[#121212]'>{selectedCategories.length}/{categories.length}</p>

                    <button onClick={handleDeleteList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Delete</button>

                    <button onClick={handleHideList} className='px-4 py-2 rounded bg-[#FFFFFF] font-semibold text-base text-[#808080] outline-none select-none'>Hide</button>
                </div>
            }

            <Modal />
        </div>
    );
}

export default Categories;
